import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import ColorContext from '@providers/ColorProvider/context/ColorContext';
import { Link } from '@router/Link';
import { useContext } from 'react';

import coolImg from './cool_img.png';
import PlusIcon from './PlusIcon';
import styles from './styles.module.scss';
import warmImg from './warm_img.png';

function Blank() {
  const { grayTheme } = useContext(ColorContext);
  return (
        <Column className={styles.container}
                fullWidth
                as='section'
                align='center'>
            <Image src={grayTheme === 'WARM' ? warmImg : coolImg}
                   className={styles.img}
                   width={256}
                   height={256}
                   alt='선불카드' />
            <Text size='lg'>보유하고 계신 선불카드가 없습니다.</Text>
            <Link activityParams={{ type: 'BUY' }}
                  activityName='PrepaidCardImagesActivity' >
                <Column className={styles.card}
                        justify='center'
                        align='center'
                        spacing={4} >
                    <button className={styles.add}>
                        <PlusIcon/>
                    </button>
                    <Text size='lg'>새 카드 구매</Text>
                </Column>
            </Link>
        </Column>
  );
}
export default Blank;
